import React from "react";
import {
  settingsPrimaryButtonClassName,
  settingsResetButtonClassName,
} from "./settingsStyles";

export type SectionSaveResetProps = {
  isDirty: boolean;
  saving: boolean;
  lastSavedLabel: string;
  onSave: () => void | Promise<void>;
  onReset: () => void;
  statusText?: string | null;
  errorText?: string | null;
};

const SectionSaveReset = ({
  isDirty,
  saving,
  lastSavedLabel,
  onSave,
  onReset,
  statusText,
  errorText,
}: SectionSaveResetProps) => (
  <div className="mt-6">
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-end">
      <button
        type="button"
        onClick={onReset}
        disabled={!isDirty || saving}
        className={`${settingsResetButtonClassName} w-full sm:w-[180px]`}
      >
        Reset
      </button>
      <div className="flex w-full flex-col sm:w-[280px] sm:items-end">
        <button
          type="button"
          onClick={onSave}
          disabled={!isDirty || saving}
          className={`${settingsPrimaryButtonClassName} w-full`}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
        <p
          className={`mt-2 whitespace-nowrap text-center text-sm sm:text-right ${
            errorText ? "text-red-600" : statusText ? "text-gray-900" : "text-gray-500"
          }`}
        >
          {errorText || statusText || lastSavedLabel}
        </p>
      </div>
    </div>
  </div>
);

export default SectionSaveReset;
